var map = {
	"./App.png": "f800",
	"./Facebook.png": "4774",
	"./Instagram.png": "4d7c",
	"./Newsletter.png": "d392",
	"./Other.png": "831e",
	"./SMS.png": "ff3f",
	"./Youtube.png": "3564"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "978d";